import { router } from '../../router';
import authRepository from '../../repositories/auth.repository';


export const auth = {
    getters: {
        isAuthenticated(state, getters, rootState){
            return !!rootState.user;
        }
    },
    actions: {
        authenticate({commit, actions}, payload){
            authRepository.authenticate(payload.user, payload.pass)
            .then(data => {
                // commit('SET_USER', data);
                actions('setUserAction', data);
            });
        },
        setUserAction({rootState}, user){
            rootState.user = user;
        }
    },
    mutations: {
        'SET_USER'(state, user){
            state.user = user;
        }
    }
}